import { useState } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { CURRENCIES, SUPPLY_OPTS, parseTr } from "@/lib/lineMath";

const Field = ({ label, testId, onApply, placeholder }) => {
  const [v, setV] = useState("");
  const apply = () => { if (v.trim() === "") return; onApply(Math.min(100, Math.max(0, parseTr(v)))); setV(""); };
  return (
    <div className="flex items-center gap-1">
      <span className="text-[10px] uppercase tracking-wider font-mono text-blue-200/80">{label}</span>
      <input value={v} onChange={(e) => setV(e.target.value)} placeholder={placeholder} data-testid={`${testId}-input`}
        onKeyDown={(e) => e.key === "Enter" && apply()}
        className="h-7 w-16 bg-slate-950 border border-blue-500/40 rounded-[3px] text-right font-mono text-xs px-1.5 outline-none focus:border-blue-400" />
      <Button size="sm" onClick={apply} data-testid={`${testId}-apply`} className="h-7 px-2 text-[11px] rounded-[3px] bg-blue-600 hover:bg-blue-500">Uygula</Button>
    </div>
  );
};

export default function BulkBar({ count, onTax, onDisc, onCurrency, onClear, onSupply, warehouses, onWarehouse }) {
  const [cur, setCur] = useState("EUR");
  const [sup, setSup] = useState("stock");
  const [wh, setWh] = useState("");
  if (!count) return null;
  return (
    <div data-testid="ws-bulk-bar"
      className="flex flex-wrap items-center gap-x-5 gap-y-2 px-4 py-2 bg-blue-950/50 border-b border-blue-500/30 animate-in fade-in slide-in-from-top-1 duration-150">
      <span className="text-xs font-semibold text-blue-100" data-testid="ws-bulk-count">{count} satır seçildi</span>
      <Field label="KDV %" testId="ws-bulk-tax" placeholder="20" onApply={onTax} />
      <Field label="İskonto %" testId="ws-bulk-disc" placeholder="5" onApply={onDisc} />
      <div className="flex items-center gap-1">
        <span className="text-[10px] uppercase tracking-wider font-mono text-blue-200/80">Para Birimi</span>
        <select value={cur} onChange={(e) => setCur(e.target.value)} data-testid="ws-bulk-cur-select"
          className="h-7 bg-slate-950 border border-blue-500/40 rounded-[3px] font-mono text-xs px-1 outline-none">
          {CURRENCIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <Button size="sm" onClick={() => onCurrency(cur)} data-testid="ws-bulk-cur-apply" className="h-7 px-2 text-[11px] rounded-[3px] bg-blue-600 hover:bg-blue-500">Uygula</Button>
      </div>
      {onSupply && (
        <div className="flex items-center gap-1">
          <span className="text-[10px] uppercase tracking-wider font-mono text-blue-200/80">Tedarik</span>
          <select value={sup} onChange={(e) => setSup(e.target.value)} data-testid="ws-bulk-supply-select"
            className="h-7 bg-slate-950 border border-blue-500/40 rounded-[3px] text-xs px-1 outline-none">
            {SUPPLY_OPTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <Button size="sm" onClick={() => onSupply(sup)} data-testid="ws-bulk-supply-apply" className="h-7 px-2 text-[11px] rounded-[3px] bg-blue-600 hover:bg-blue-500">Uygula</Button>
        </div>
      )}
      {warehouses && (
        <div className="flex items-center gap-1">
          <span className="text-[10px] uppercase tracking-wider font-mono text-blue-200/80">Depo</span>
          <select value={wh} onChange={(e) => setWh(e.target.value)} data-testid="ws-bulk-wh-select"
            className="h-7 max-w-[160px] bg-slate-950 border border-blue-500/40 rounded-[3px] text-xs px-1 outline-none">
            <option value="">Depo seçin</option>
            {warehouses.map((w) => <option key={w.id} value={w.id}>{w.name}</option>)}
          </select>
          <Button size="sm" disabled={!wh} onClick={() => onWarehouse(wh)} data-testid="ws-bulk-wh-apply" className="h-7 px-2 text-[11px] rounded-[3px] bg-blue-600 hover:bg-blue-500">Uygula</Button>
        </div>
      )}
      <button type="button" onClick={onClear} data-testid="ws-bulk-clear" className="ml-auto text-blue-200/70 hover:text-white text-xs inline-flex items-center gap-1">
        <X className="w-3.5 h-3.5" /> Seçimi temizle
      </button>
    </div>
  );
}
